import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';
import toggledImage from '../assets/toggled-image.png';
import SectionHeading from './section-heading';

class ToggledDiv extends Component {
  render() {
    return(
      <div className="le-toggled-div">
        <Row>
          <Col md={6} className="toggle-image">
            <img src={toggledImage} alt="toggled-img" />
          </Col>
          <Col md={6} className="toggle-text">
            <SectionHeading subText="JUST A SUB HEADING" heading="A headline to be given" align="heading-left"/>
            <p>
              Its just a Paragraph which is classy yet gives you much information that you want to know about something which might lead you to do some action that you want to take 
            </p>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={6} className="toggle-text">
            <SectionHeading subText="JUST A SUB HEADING" heading="A headline to be given" align="heading-left"/>
            <p>
              Its just a Paragraph which is classy yet gives you much information that you want to know about something which might lead you to do some action that you want to take 
            </p>
          </Col>
          <Col md={6} className="toggle-image">
            <img src={toggledImage} alt="toggled-img" />
          </Col>
        </Row>
      </div>
    )
  }
}

export default ToggledDiv;